module.exports = __webpack_public_path__ + "assets/img/189c1938c52433c4cb18e1842b0ed978.png";